import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import { computed, toRef } from 'vue'

    import type { MeetingStopperViewModel } from '@Evaluation/Estimations/Components/MeetingStopper'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingStopper',
  props: {
    viewModel: {}
  },
  emits: ["stopMeeting", "openSurvey", "closeSurvey"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const surveyStarted = computed(() => vm.value.surveyStarted)

    // ---------------- actions ----------------

    function stopMeeting()
    {
        emit('stopMeeting')
    }

    function openSurvey()
    {
        emit('openSurvey')
    }

    function closeSurvey()
    {
        emit('closeSurvey')
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Stopping the meeting", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "lead" }, " You're about to end the meeting. Let's just tidy up a little... ", -1 /* CACHED */)),
                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("tbody", null, [
                    (surveyStarted.value)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                          _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                            _createElementVNode("h5", null, "Survey is open"),
                            _createElementVNode("p", null, "The survey is still open. This means that people can still change their votes.​")
                          ], -1 /* CACHED */)),
                          _createElementVNode("td", { class: "align-middle" }, [
                            _createElementVNode("button", {
                              class: "btn btn-outline-secondary btn-block text-nowrap",
                              onClick: closeSurvey
                            }, "Close survey")
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (!surveyStarted.value)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                          _cache[2] || (_cache[2] = _createElementVNode("td", null, [
                            _createElementVNode("h5", null, "Survey is closed"),
                            _createElementVNode("p", null, "The survey is closed. This means that people cannot change their votes.​")
                          ], -1 /* CACHED */)),
                          _createElementVNode("td", { class: "align-middle" }, [
                            _createElementVNode("button", {
                              class: "btn btn-outline-secondary btn-block text-nowrap",
                              onClick: openSurvey
                            }, "Open survey")
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: stopMeeting,
                  type: "button",
                  class: "btn btn-primary"
                }, "Stop the meeting"),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})